
import { useState, useEffect } from "react";
import { FileItem } from "./types";
import { fileStorage } from "@/utils/fileStorage";
import { fileCategories, getCategoryLabel } from "./constants";
import { useFileEditing } from "./hooks/useFileEditing";
import { useFileDelete } from "./hooks/useFileDelete";
import { useNewFile } from "./hooks/useNewFile";

// Export fileCategories for use in other components
export { fileCategories, getCategoryLabel };

export const useFileManagement = () => {
  // Load files from localStorage using our fileStorage utility
  const [files, setFiles] = useState<FileItem[]>(() => {
    return fileStorage.getAllFiles();
  });
  
  // Import functionality from smaller hooks
  const { 
    editingFile, 
    newFileName, 
    setNewFileName, 
    setEditingFile, 
    startEditingFile, 
    saveFileNameEdit 
  } = useFileEditing(files, setFiles);
  
  const { handleDeleteFile } = useFileDelete(files, setFiles);
  
  const {
    newFile,
    setNewFile,
    handleNewFileChange,
    handleAddFile
  } = useNewFile(files, setFiles);

  // Save files to the database (localStorage) whenever they change
  useEffect(() => {
    fileStorage.saveFiles(files);
  }, [files]);

  // Get files by category
  const getFilesByCategory = (category: string) => {
    return fileStorage.getFilesByCategory(category);
  };

  return {
    files,
    editingFile,
    newFileName,
    newFile,
    setNewFileName,
    setEditingFile,
    setNewFile,
    handleDeleteFile,
    startEditingFile,
    saveFileNameEdit,
    handleNewFileChange,
    handleAddFile,
    getFilesByCategory,
    getCategoryLabel,
  };
};
